import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../../core/services/base-api.service';
import { Library } from '../../types/library';
import { KohaBiblioDto } from '../../shared/models/koha/koha-biblio.dto';

@Injectable({
  providedIn: 'root'
})
export class HomeService extends BaseApiService {
  protected override basePath = '/api/v1';

  getTopLibraries(): Observable<Library[]> {
    console.log("Librareis working fine ")
    let params = new HttpParams()
      .set('_per_page', '3')
      .set('_page', '1');

    const headers = { 'x-koha-embed': 'library_hours' };
    return this.getWithCount<Library[]>('/libraries', params, headers).pipe(
      map(response => response.data || [])
    );
  }

  getLibraryKAW(): Observable<Library> {
    const headers = { 'x-koha-embed': 'library_hours' };
    return this.get<Library>('/libraries/KAW', undefined, headers);
  }

  /**
   * Latest catalogue records.
   *
   * @param perPage how many records to fetch. Defaults to 3, which is what the
   *   original home page renders as a static row; the redesigned home page asks
   *   for more so its carousel has something to page through.
   */
  getLatestBiblios(perPage = 3): Observable<KohaBiblioDto[]> {
    console.log("biblios working fine ")
    let params = new HttpParams()
      // newest first (Koha accepts a leading '-' for descending order)
      .set('_order_by', '-biblio_id')
      .set('_per_page', String(perPage))
      .set('_page', '1');

    return this.getWithCount<KohaBiblioDto[]>('/biblios', params).pipe(
      map(response => response.data || [])
    );
  }
}
